/* Quick add (Oct 2026) — the "+" on product cards.
   Opens a branded window with the piece's photos, name, price and its size choices, then adds it to
   the bag through the theme's cart drawer. See snippets/quick-add.liquid for the rules. */
(function () {
  'use strict';
  var root = document.getElementById('qa');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('qa-config').textContent); } catch (e) {}
  var panel = root.querySelector('.qa-panel');
  var track = root.querySelector('[data-qa-track]');
  var dotsEl = root.querySelector('[data-qa-dots]');
  var storyEl = root.querySelector('[data-qa-story]');
  var titleEl = root.querySelector('[data-qa-title]');
  var priceEl = root.querySelector('[data-qa-price]');
  var form = root.querySelector('[data-qa-form]');
  var idInput = root.querySelector('[data-qa-id]');
  var optsEl = root.querySelector('[data-qa-options]');
  var setNote = root.querySelector('[data-qa-setnote]');
  var msgEl = root.querySelector('[data-qa-msg]');
  var atc = root.querySelector('[data-qa-atc]');
  var atcText = root.querySelector('[data-qa-atc-text]');
  var atcPrice = root.querySelector('[data-qa-atc-price]');
  var notify = root.querySelector('[data-qa-notify]');
  var details = root.querySelector('[data-qa-details]');
  var direct = root.getAttribute('data-direct') === 'true';
  var cache = {};
  var state = null, opener = null, openSeq = 0, skeleton = optsEl.innerHTML;

  /* ---------- money, in the shop's own format (keeps the currency app's <span class="money">) ---------- */
  function money(cents) {
    var f = String(cfg.moneyFormat || '{{amount}}');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      var v = (cents || 0) / 100;
      var opts = { minimumFractionDigits: 3, maximumFractionDigits: 3 };
      if (name.indexOf('no_decimals') !== -1) { opts = { minimumFractionDigits: 0, maximumFractionDigits: 0 }; }
      if (name.indexOf('comma_separator') !== -1) return v.toLocaleString('de-DE', opts);
      return v.toLocaleString('en-US', opts);
    });
  }
  function text(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(src, w) {
    if (!src) return '';
    src = String(src).replace(/^http:/, 'https:');
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---------- product data ---------- */
  function load(url) {
    var key = url.split('?')[0];
    if (!cache[key]) {
      cache[key] = fetch(key + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
        .catch(function (e) { delete cache[key]; throw e; });
    }
    return cache[key];
  }

  // "Whale Adult Pajama (Size)" → { piece: "Whale Adult Pajama", isSize: true }
  function parseOption(name) {
    var m = String(name).match(/^(.*?)\s*\((size|sizes|المقاس|مقاس)\)\s*$/i);
    if (m) return { piece: m[1].trim(), isSize: true, name: name };
    var isSize = /^(size|sizes|المقاس|مقاس|الحجم)$/i.test(String(name).trim());
    return { piece: '', isSize: isSize, name: name };
  }

  /* ---------- open / close ---------- */
  function lockScroll(on) {
    document.documentElement.classList.toggle('qa-lock', on);
    document.body.style.overflow = on ? 'hidden' : (document.body.classList.contains('cartd-open') ? 'hidden' : '');
  }

  // The window only appears once the product data is in, so it opens at its final size
  // (it used to open small with placeholders and then grow). The data is usually already there:
  // it is fetched the moment a finger touches the "+". If it is still on its way, the "+" shows a
  // small spinner meanwhile; after 2.5 s the window opens anyway with placeholders.
  var loaded = {}, waiting = null, byKey = false;
  function open(btn) {
    var url = btn.getAttribute('data-qa-url');
    if (!url) return;
    var key = url.split('?')[0];
    var seq = ++openSeq;
    if (waiting && waiting !== btn) stopWait(waiting);
    if (loaded[key]) { show(btn, url); build(loaded[key], url); return; }
    waiting = btn;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    var shown = false;
    var timer = setTimeout(function () {
      if (seq !== openSeq) return;
      shown = true; stopWait(btn); show(btn, url);
    }, 2500);
    load(url).then(function (p) {
      loaded[key] = p;
      if (seq !== openSeq) return;
      clearTimeout(timer); stopWait(btn);
      if (!shown) show(btn, url);
      build(p, url);
    }).catch(function () {
      if (seq !== openSeq) return;
      clearTimeout(timer); stopWait(btn);
      // no data: take the shopper to the product page instead
      window.location.href = url;
    });
  }
  function stopWait(btn) {
    btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
    if (waiting === btn) waiting = null;
  }

  function show(btn, url) {
    opener = btn;
    var card = btn.closest('.product-card');
    var cardImg = card && card.querySelector('.card-img .main-img');
    var cardName = card && card.querySelector('.card-name');
    var cardPrice = card && card.querySelector('.card-price');
    var cardStory = card && card.querySelector('a.card-story');
    titleEl.textContent = cardName ? cardName.textContent.trim() : '';
    priceEl.innerHTML = cardPrice ? cardPrice.innerHTML : '';
    if (cardStory) { storyEl.hidden = false; storyEl.textContent = cardStory.textContent.trim(); storyEl.href = cardStory.getAttribute('href'); }
    else { storyEl.hidden = true; }
    track.innerHTML = cardImg ? '<figure class="qa-slide"><img src="' + text(cardImg.currentSrc || cardImg.src) + '" alt=""></figure>' : '';
    dotsEl.innerHTML = '';
    optsEl.innerHTML = skeleton;
    setNote.hidden = true; msgEl.textContent = ''; notify.hidden = true;
    atc.hidden = false; atc.disabled = true; atcText.textContent = cfg.add || 'Add to cart'; atcPrice.innerHTML = '';
    details.href = url;
    state = null;

    root.hidden = false;
    // next frame so the entrance transition runs
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    lockScroll(true);
    fit();
    panel.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey, true);
  }

  // The window is as tall as its content, but never taller than the screen (90% on phones,
  // 700px on desktop). Giving it a real height lets the size list scroll inside while the add
  // button stays on screen; without it a long gift set pushed the button below the edge.
  function fit() {
    if (root.hidden) return;
    panel.style.height = '';
    var phone = window.innerWidth <= 640;
    var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var max = phone ? Math.round(vh * 0.9) : Math.min(700, window.innerHeight - 48);
    panel.style.height = Math.min(panel.scrollHeight, max) + 'px';
  }
  window.addEventListener('resize', function () { if (!root.hidden) fit(); });

  function close() {
    if (waiting) stopWait(waiting);
    if (root.hidden) return;
    openSeq++;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    var done = function () { root.hidden = true; track.innerHTML = ''; panel.style.height = ''; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) done(); else setTimeout(done, 320);
    lockScroll(false);
    // give focus back to the "+" only for keyboard users (a tap or click must not leave a ring on it)
    if (opener && byKey && document.body.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    else if (opener && document.activeElement === opener) opener.blur();
    if (opener) opener.classList.remove('is-loading');
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    // keep focus inside the window
    var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.offsetParent !== null && !el.hidden;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- build the window from the product ---------- */
  function build(p, url) {
    var options = (p.options || []).map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      var values = typeof o === 'string' ? uniqueValues(p, i) : o.values;
      var info = parseOption(name);
      return { index: i, name: name, piece: info.piece, isSize: info.isSize, values: values };
    });
    var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    state = { p: p, url: url, options: single ? [] : options, sel: {}, big: p.variants.length >= 250, extra: {}, srv: null, ids: null };

    // photos: every product image, the variant photo first if one is chosen later
    var imgs = (p.images || []).slice(0, 8);
    if (!imgs.length && p.featured_image) imgs = [p.featured_image];
    track.innerHTML = imgs.map(function (src, i) {
      return '<figure class="qa-slide" data-src="' + text(String(src).split('?')[0]) + '"><img src="' + text(img(src, 720)) + '" srcset="' + text(img(src, 360)) + ' 360w, ' + text(img(src, 540)) + ' 540w, ' + text(img(src, 720)) + ' 720w, ' + text(img(src, 960)) + ' 960w" sizes="(max-width: 640px) 120px, 400px" alt="' + (i === 0 ? text(p.title) : '') + '"' + (i > 1 ? ' loading="lazy"' : '') + '></figure>';
    }).join('');
    dotsEl.innerHTML = imgs.length > 1 ? imgs.map(function (_, i) { return '<button type="button" class="qa-dot' + (i === 0 ? ' on' : '') + '" data-qa-dot="' + i + '" aria-label="' + (i + 1) + '/' + imgs.length + '"></button>'; }).join('') : '';
    track.scrollLeft = 0;

    titleEl.textContent = p.title;
    showPrice(null);

    // one row per option; a gift set with a size per piece gets one row per piece
    var pieces = state.options.filter(function (o) { return o.piece; }).length;
    setNote.hidden = pieces < 2;
    optsEl.innerHTML = state.options.map(function (o) {
      var label = o.piece
        ? '<span class="qa-opt-piece">' + text(o.piece) + '</span><span class="qa-opt-kind">' + text(cfg.size || 'Size') + '</span>'
        : '<span class="qa-opt-piece">' + text(String(cfg.choose || '__NAME__').replace('__NAME__', o.name).replace(/[:：]\s*$/, '')) + '</span>';
      return '<fieldset class="qa-opt" data-qa-opt="' + o.index + '"><legend class="qa-opt-label">' + label + '<span class="qa-opt-need" aria-hidden="true">' + text(cfg.required || '') + '</span><span class="qa-opt-picked" data-qa-picked></span></legend><div class="qa-vals">' +
        o.values.map(function (v) {
          return '<button type="button" class="qa-val" data-qa-val="' + text(v) + '" aria-pressed="false">' + text(v) + '</button>';
        }).join('') + '</div></fieldset>';
    }).join('');

    // an option with only one value is chosen for the shopper
    state.options.forEach(function (o) { if (o.values.length === 1) state.sel[o.index] = o.values[0]; });
    refresh();
    if (state.big) server(null).catch(function () {});

    fit();
    if (single && direct) { add(); }
  }

  function uniqueValues(p, i) {
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var x = v.options[i]; if (!seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  // Products with more than 250 combinations: the product data stops at 250, so the rest are
  // looked up on the server (sections/quick-add-data.liquid) when the shopper completes a choice.
  function selKey(sel) { return state.options.map(function (o) { return sel[o.index]; }).join('\u0001'); }
  function server(sel) {
    var st = state, q = '';
    if (sel) {
      if (!st.ids) return server(null).then(function () { return server(sel); });
      q = '&option_values=' + st.options.map(function (o) { return st.ids[o.index][sel[o.index]]; }).join(',');
    }
    return fetch(st.url.split('?')[0] + '?section_id=quick-add-data' + q, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-qa-data>([\s\S]*?)<\/script>/);
        var d = JSON.parse(m[1]);
        if (!st.ids) {
          st.ids = {};
          d.options.forEach(function (o, i) { st.ids[i] = {}; o.values.forEach(function (v) { st.ids[i][v.name] = v.id; }); });
        }
        return d;
      });
  }
  function variantFor(sel) {
    var p = state.p;
    if (!state.options.length) return p.variants[0];
    if (state.extra[selKey(sel)]) return state.extra[selKey(sel)];
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var k = 0; k < state.options.length; k++) { if (v.options[state.options[k].index] !== sel[state.options[k].index]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  // a value is open if some variant that exists and is in stock carries it with the other choices made so far
  function valueOpen(idx, value) {
    if (state.big) {
      if (!state.srv) return true; // not known until a full choice is made
      var o = state.srv.options[idx], hit = null;
      for (var i = 0; o && i < o.values.length; i++) if (o.values[i].name === value) hit = o.values[i];
      return !hit || (hit.exists !== false && hit.available !== false);
    }
    return state.p.variants.some(function (v) {
      if (!v.available || v.options[idx] !== value) return false;
      for (var k in state.sel) { if (parseInt(k, 10) !== idx && v.options[k] !== state.sel[k]) return false; }
      return true;
    });
  }

  function showPrice(v) {
    var p = state.p;
    var price = v ? v.price : p.price, cmp = v ? v.compare_at_price : p.compare_at_price;
    var from = !v && p.price_varies;
    if (cmp && cmp > price) priceEl.innerHTML = '<span class="qa-price-sale">' + money(price) + '</span> <s class="qa-price-was">' + money(cmp) + '</s>';
    else priceEl.innerHTML = (from ? '<span class="qa-from">' + money(p.price_min) + '</span>' : '<span>' + money(price) + '</span>');
  }

  function refresh() {
    var missing = [];
    state.options.forEach(function (o) {
      var box = optsEl.querySelector('[data-qa-opt="' + o.index + '"]');
      if (!box) return;
      Array.prototype.forEach.call(box.querySelectorAll('.qa-val'), function (b) {
        var val = b.getAttribute('data-qa-val');
        var on = state.sel[o.index] === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var openV = valueOpen(o.index, val);
        b.classList.toggle('is-out', !openV);
        if (!openV) b.setAttribute('aria-label', val + ' — ' + (cfg.soldout || '')); else b.removeAttribute('aria-label');
      });
      var picked = box.querySelector('[data-qa-picked]');
      if (picked) picked.textContent = state.sel[o.index] && o.values.length > 1 ? state.sel[o.index] : '';
      if (state.sel[o.index] == null) missing.push(o); else box.classList.remove('is-missing');
    });

    msgEl.textContent = ''; msgEl.classList.remove('is-hint');
    notify.hidden = true; atc.hidden = false;
    atcPrice.innerHTML = '';
    state.missing = missing;
    atc.classList.toggle('is-incomplete', missing.length > 0);
    if (missing.length) atc.setAttribute('aria-disabled', 'true'); else atc.removeAttribute('aria-disabled');
    if (missing.length) {
      var multi = state.options.filter(function (o) { return o.piece; }).length > 1;
      var m = missing[0];
      atcText.textContent = multi ? (cfg.selectEach || '') : m.isSize ? (cfg.selectSize || '') : String(cfg.select || '__NAME__').replace('__NAME__', m.name);
      atc.disabled = false;
      idInput.value = '';
      showPrice(null);
      return;
    }
    var v = variantFor(state.sel);
    if (state.big && (!v || !state.srvFor || state.srvFor !== selKey(state.sel))) {
      var key = selKey(state.sel), st = state;
      if (st.pending !== key) {
        st.pending = key;
        atc.disabled = true; atcText.textContent = '…';
        server(st.sel).then(function (d) {
          if (state !== st || st.pending !== key) return;
          st.pending = null; st.srv = d; st.srvFor = key;
          var sv = d.variant;
          var match = sv && st.options.every(function (o) { return sv.options[o.index] === st.sel[o.index]; });
          if (match) st.extra[key] = sv;
          refresh();
        }).catch(function () { st.pending = null; st.srvFor = key; refresh(); });
      }
      if (!v) return;
    }
    if (!v) {
      // this combination was never made (e.g. a set with more size mixes than a product can hold)
      atcText.textContent = cfg.unavailable || cfg.soldout || '';
      atc.disabled = true; idInput.value = '';
      showPrice(null);
      return;
    }
    idInput.value = v.id;
    showPrice(v);
    if (v.featured_image && v.featured_image.src) goToImage(v.featured_image.src);
    if (v.available) {
      atcText.textContent = cfg.add || '';
      atcPrice.innerHTML = money(v.price);
      atc.disabled = false;
    } else {
      // sold out: the product page has the back-in-stock form for this exact choice
      atc.hidden = true;
      notify.hidden = false;
      notify.href = state.url + (state.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id + '#pdp-notify-form';
    }
  }

  function goToImage(src) {
    var key = String(src).split('?')[0].replace(/^https?:/, '');
    var slides = track.querySelectorAll('.qa-slide');
    for (var i = 0; i < slides.length; i++) {
      var s = (slides[i].getAttribute('data-src') || '').replace(/^https?:/, '');
      if (s && s === key) { scrollToSlide(i); return; }
    }
  }
  function scrollToSlide(i) {
    var s = track.querySelectorAll('.qa-slide')[i];
    if (!s) return;
    var rtl = getComputedStyle(track).direction === 'rtl';
    var x = rtl ? -(track.scrollWidth - s.offsetLeft - s.offsetWidth) : s.offsetLeft;
    try { track.scrollTo({ left: rtl ? -Math.abs(x) : x, behavior: 'smooth' }); } catch (e) { track.scrollLeft = x; }
    setDot(i);
  }
  function setDot(i) {
    Array.prototype.forEach.call(dotsEl.querySelectorAll('.qa-dot'), function (d, k) { d.classList.toggle('on', k === i); });
  }
  track.addEventListener('scroll', function () {
    var w = track.clientWidth || 1;
    setDot(Math.round(Math.abs(track.scrollLeft) / w));
  }, { passive: true });

  /* ---------- add to bag ---------- */
  // Tapping the button before every choice is made: each missing row turns gold with a
  // "Please choose" tag and a small sideways nudge. The button itself already says what to do.
  function remind() {
    var miss = state.missing || [];
    var multi = state.options.filter(function (o) { return o.piece; }).length > 1;
    miss.forEach(function (o) {
      var box = optsEl.querySelector('[data-qa-opt="' + o.index + '"]');
      if (!box) return;
      box.classList.remove('is-missing'); void box.offsetWidth; box.classList.add('is-missing');
    });
    // nothing else moves: no scrolling and no extra line, so the sizes stay exactly in place
  }

  function add() {
    if (state && state.missing && state.missing.length) { remind(); return; }
    var id = parseInt(idInput.value, 10);
    if (!id) return;
    atc.disabled = true;
    atc.classList.add('is-busy');
    atcText.textContent = cfg.adding || cfg.add || '';
    msgEl.textContent = '';
    var cartAdd = (cfg.cartAdd || ((window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add')) + '.js';
    fetch(cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        atc.classList.remove('is-busy');
        if (!res.ok || (res.j && res.j.status && res.j.status !== 200)) {
          msgEl.textContent = (res.j && (res.j.description || res.j.message)) || cfg.error || '';
          refresh();
          return;
        }
        close();
        if (window.AdamCart && window.AdamCart.added) window.AdamCart.added();
        else window.location.href = (window.themeRoutes && window.themeRoutes.root || '/') + 'cart';
      })
      .catch(function () {
        atc.classList.remove('is-busy');
        msgEl.textContent = cfg.error || '';
        refresh();
      });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qa-url]');
    if (btn && btn.classList.contains('qa-btn')) { e.preventDefault(); e.stopPropagation(); byKey = e.detail === 0; if (!byKey) btn.blur(); open(btn); return; }
    if (root.hidden) return;
    if (e.target.closest('[data-qa-close]')) { e.preventDefault(); close(); return; }
    var dot = e.target.closest('[data-qa-dot]');
    if (dot) { scrollToSlide(parseInt(dot.getAttribute('data-qa-dot'), 10)); return; }
    var val = e.target.closest('.qa-val');
    if (val && state) {
      var box = val.closest('[data-qa-opt]');
      var idx = parseInt(box.getAttribute('data-qa-opt'), 10);
      state.sel[idx] = val.getAttribute('data-qa-val');
      refresh();
    }
  });
  // warm the product data as soon as a finger or pointer reaches the button
  ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.qa-btn[data-qa-url]') : null;
      if (t) load(t.getAttribute('data-qa-url')).catch(function () {});
    }, { passive: true, capture: true });
  });
  // our own submit, so the theme's generic handler (which would show a browser alert on errors) stays out of it
  form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); add(); });
  // the theme re-renders sections in the editor
  document.addEventListener('shopify:section:load', function () { if (!root.hidden) close(); });
})();
